$(function() {
  if(window.location.href == "https://everynow-andthen.com/") {
    $('body').addClass('home');

    $('.big-carousel').slick({
      dots: false,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 5000,
      pauseOnHover: false,
      infinite: true,
      fade: true,
      centerMode: true,
      adaptiveHeight: true
    });

    // $('.big-carousel').addClass('engaged');
    
    $('.big-carousel').hover(function() {
      $(this).addClass('engaged');
    }, function() {
      $(this).removeClass('engaged');
    });

    $('.no-touchevents .list-menu__item').hover(function() {
      // $('body').addClass('inverted');
      // $('.header-wrapper').addClass('inverted');
      // $('.announcement-bar').addClass('inverted');
    }, function() {
      // $('body').removeClass('inverted');
      // $('.header-wrapper').removeClass('inverted');
      // $('.announcement-bar').removeClass('inverted');
    });
  }

  console.log(window.location.href.indexOf("/pages/contact"));
  if(window.location.href.indexOf("/pages/contact") > -1) {
    $('#MainContent').addClass('contactPage');
  }

  $('.footer-block__details-content li').each(function() {
    var fl_text = $(this).find('a').text().trim();
    if (fl_text == "Terms & Conditions") {
      $(this).find('a').prop('target', '');
    }
    if (fl_text == "Privacy Policy") {
      $(this).find('a').prop('target', '');
    }
  });
});